import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import TodoTemplateMainTable from "@/components/todoTemplate/todoTemplateMainTable";

const TodoTemplateList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_todo_template">
      <TodoTemplateMainTable />
    </RestrictedPage>
  );
};

export default TodoTemplateList;
